import React, { useEffect, useState, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import UserContext from "../context/UserContext";
import { api } from "../utils/apiHelper";
import "../styles/DigiPrev.css";

const CustomAudioPlayer = ({ src }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);

  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleTimeUpdate = () => {
    const audio = audioRef.current;
    if (!audio) return;

    setProgress((audio.currentTime / audio.duration) * 100);
    setDuration(audio.duration);
  };

  return (
    <div className="custom-audio-player">
      <audio
        ref={audioRef}
        src={src}
        onTimeUpdate={handleTimeUpdate}
        onEnded={() => setIsPlaying(false)}
        preload="none"
      />
      <button onClick={togglePlay} className="play-button">
        {isPlaying ? "⏸" : "▶️"}
      </button>
      <div className="progress-container">
        <div className="progress-bar" style={{ width: `${progress}%` }} />
      </div>
       {/*<div className="duration">  {duration ? `${Math.floor(duration)}s` : "--"} </div> */}
    </div>
  );
};

const DigiPrev = () => {
  const { authUser } = useContext(UserContext);
  const { userId } = useParams(); // get userId from URL
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStore = async () => {
      try {
        const data = await api(`/digi-store/${userId}`);
        if (Array.isArray(data)) {
          const withOwnerId = data.map((p) => ({ ...p, ownerId: userId }));
          setProducts(withOwnerId);
        } else {
          console.error("Unexpected data format:", data);
        }
      } catch (error) {
        console.error("Error fetching store:", error);
      } finally {
        setLoading(false);
      }
    };

    if (userId) fetchStore();
  }, [userId]);

  const handleAddToCart = async (project) => {
    const payload = {
      userId: authUser._id,
      ownerId: project.ownerId,
      projectId: project.projectId,
      projectTitle: project.projectTitle,
    };

    try {
      const response = await api("/cart/add-audio", "POST", payload);
      if (response?.message === "Audio product added to cart.") {
        alert("Product added to cart.");
      } else {
        console.error("Unexpected response:", response);
        alert("Failed to add product to cart.");
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      alert("Server error while adding to cart.");
    }
  };

  if (loading) return <p>Loading products...</p>;
  if (products.length === 0) return <p>No products found.</p>;

  return (
    <div className="digi-store-container">
      <h2>Browse Digital Products</h2>

      {products.map((project) => (
        <div key={project.projectId} className="digiprev-product-card">
          {project.imageUrl && (
            <div className="product-image">
              <img
                src={project.imageUrl}
                alt={project.projectTitle}
                style={{ maxWidth: "100%", borderRadius: "12px" }}
              />
            </div>
          )}

          <div className="product-meta">
            <h3 className="digiprev-product-title">{project.projectTitle}</h3>
            <p><strong>Description:</strong> {project.description}</p>
            <p><strong>Price:</strong> ${project.price}</p>
            <p><strong>License:</strong> {project.licenseType}</p>
            {project.quantity !== null && project.quantity !== undefined && (
              <p><strong>Quantity Available:</strong> {project.quantity}</p>
            )}
          </div>

          <h4>Audio Preview</h4>
          {project.files.length > 0 ? (
            <ul className="new-list">
              {project.files.map((file) => (
               <li key={file.fileId} className="audio-row">
  {file.url ? (
    <>
      <CustomAudioPlayer src={file.url} />
      <p className="file-name">{file.fileName}</p>
    </>
  ) : (
    <p>Preview unavailable.</p>
  )}
</li>
              ))}
            </ul>
          ) : (
            <p>No audio files available.</p>
          )}

          <button className="add-to-cart-button" onClick={() => handleAddToCart(project)}>
            Add to Cart
          </button>
        </div>
      ))}
    </div>
  );
};

export default DigiPrev;
